import * as profileRoutines from './profileRoutines';
import produce from 'immer';

const initialState = {
    isProfilePicRequired: false,
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case profileRoutines.toggleProfilePicRequired.SUCCESS:
            return produce(state, draft => {
                draft.isProfilePicRequired = action.payload;
            });

        default:
            return state;
    }
}
